<template>
  <div class="flex flex-col gap-2 justify-start w-3 relative cursor-pointer"
       @click="$emit('click:sorter', { columnId, order: sort === 'asc' ? 'desc' : 'asc' })"
  >
    <sortable-table-arrows-sort v-for="order in ['asc', 'desc']"
                                :key="order"
                                :is-active="order === sort"
                                :order="order"
    />
  </div>
</template>

<script>
import SortableTableArrowsSort from '@/components/common/SortableTableArrowsSort'

export default {
  name: 'SortableTableArrows',

  components: {
    SortableTableArrowsSort
  },

  props: {
    columnId: {
      type: Number,
      required: true
    },
    sort: {
      type: String,
      default: ''
    },
    displaySorters: {
      type: Boolean,
      default: false
    }
  }
}
</script>
